import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link as RouterLink } from "@reach/router";

import TopLogo from "./../../utility/TopLogo";
import FacebookIcon from "./../../utility/FacebookIcon";
import TwitterIcon from "./../../utility/TwitterIcon";

const Footer = ({
  sideNavCategoryData: categoryData,
  sideNavLoading: categoryLoading,
}) => {
  const [catToDisplay, setCatToDisplay] = useState({});
  useEffect(() => {
    let formattedCategories = {};
    if (!categoryData) return;
    if (!categoryData.getCategoriesSideMenu) return;

    categoryData.getCategoriesSideMenu.forEach((eachCat) => {
      if (formattedCategories[eachCat.categoryHeading]) {
        formattedCategories[eachCat.categoryHeading].push(eachCat);
      } else {
        formattedCategories[eachCat.categoryHeading] = [];
        formattedCategories[eachCat.categoryHeading].push(eachCat);
      }

      if (eachCat.subCategories) {
        eachCat.subCategories.forEach((eachSubCat) => {
          if (formattedCategories[eachSubCat.categoryHeading]) {
            formattedCategories[eachSubCat.categoryHeading].push(eachSubCat);
          } else {
            formattedCategories[eachSubCat.categoryHeading] = [];
            formattedCategories[eachSubCat.categoryHeading].push(eachSubCat);
          }
        });
      }
    });
    setCatToDisplay(formattedCategories);
  }, [categoryData]);

  return (
    <FooterContainer>
      <FooterContent>
        <LeftSideFooter>
          <LogoContainer>
            <Link to="/">
              <TopLogo
                removePositioning
                customStyles={{ width: "100%", height: "auto" }}
              />
            </Link>
          </LogoContainer>

          <Information>
            नयाँ युगबोध पब्लिकेशन प्रा.लि.द्वारा प्रकाशित
          </Information>
          <Link to="/">
            <Title>
              नयाँ युगबोध राष्ट्रिय दैनिकको <SubTitle>अनलाइन संस्करण</SubTitle>
            </Title>
          </Link>
          <Information>
            अध्यक्ष : प्रताप रेग्मी, <br />
            सम्पादक : लक्ष्मी आचार्य, <br />
          </Information>
          <InfosGrid>
            <EachInfo>
              <LeftSideInfo bold>प्रधान कार्यालय :</LeftSideInfo>
              <LeftSideInfo>घोराही, दाङ</LeftSideInfo>
              <LeftSideInfo>फोन नं : ०८२–५६००८४</LeftSideInfo>
            </EachInfo>
            <EachInfo>
              <LeftSideInfo bold>शाखा कार्यालयहरु :</LeftSideInfo>
              <LeftSideInfo>तुलसीपुर : ०८२–५२०९४८</LeftSideInfo>
              <LeftSideInfo>लमही : ०८२–५४०२४१</LeftSideInfo>
            </EachInfo>
          </InfosGrid>
          <LeftSideInfo>Email : yougbodh@gmail.com</LeftSideInfo>
          <SocialLinksContainer>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://facebook.com/yougbodh"
            >
              <FacebookIcon size="2x" customStyles={{ color: "#333" }} />
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://twitter.com/Yougbodh"
            >
              <TwitterIcon
                size="2x"
                customStyles={{ color: "#333", marginLeft: "10px" }}
              />
            </a>
          </SocialLinksContainer>
        </LeftSideFooter>
        <RightSideFooter>
          {Object.keys(catToDisplay).length > 1 &&
            Object.keys(catToDisplay).map((eachKey) => (
              <LinksContainer key={eachKey}>
                <LinksHeader>{eachKey}</LinksHeader>

                {catToDisplay[eachKey].map((eachCat) => (
                  <Link key={eachCat.permalink} to={eachCat.permalink}>
                    {eachCat.nepaliName}
                  </Link>
                ))}
              </LinksContainer>
            ))}
        </RightSideFooter>
      </FooterContent>
      <Copyright>
        &copy; Copyright {new Date().getFullYear()} नयाँ युगबोध राष्ट्रिय दैनिक.
        All Rights Reserved.
      </Copyright>
    </FooterContainer>
  );
};

const FooterContainer = styled.footer`
  background-color: #f7f5f4;
  margin-top: 10rem;
  color: #232323;

  @media (max-width: 1230px) {
    padding: 0 2rem;
  }
`;

const FooterContent = styled.div`
  max-width: 120rem;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 3rem;
  border-bottom: 1px solid #b2b2b2;

  @media (max-width: 750px) {
    grid-template-columns: 1fr;
    grid-gap: 1rem;
  }
`;

const LeftSideFooter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-top: 2rem;
  justify-content: flex-start;
  position: relative;
`;

const LogoContainer = styled.figure`
  width: 10rem;
  height: 20rem;
  position: absolute;
  border-radius: 200px;
  top: -7.5rem;
  z-index: 0;
  padding: 2rem;
  background-color: #f7f5f4;
`;

const Title = styled.h2`
  transition: color 0.2s;
  display: flex;
  gap: 10px;
`;

const InfosGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin: 1.5rem 0 0.5rem 0;
`;

const EachInfo = styled.div`
  &:first-child {
    padding-right: 2rem;
    border-right: 1px solid #b2b2b2;
  }

  &:last-child {
    padding-left: 2rem;
  }
`;

const LeftSideInfo = styled.p`
  ${({ bold }) => (bold ? "font-weight: bold;" : "")}
  position: relative;
  z-index: 1;
`;
const Information = styled.p`
  font-weight: bold;
  position: relative;
  z-index: 1;
  margin-top: 5px;
`;
const SubTitle = styled.p`
  font-size: 16px;
  font-style: italic;
  font-weight: bold;
  position: relative;
  z-index: 1;
  margin-top: 5px;
`;

const SocialLinksContainer = styled.div`
  position: relative;
  width: 100%;
  margin: 1rem 0;
`;

const RightSideFooter = styled.div`
  display: flex;
  align-items: flex-top;
  justify-content: space-evenly;
  margin: 2rem 0;

  @media (max-width: 750px) {
    margin: 1rem 0 1rem 0;
  }
`;

const LinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 1.75rem;
  color: #555;
`;

const LinksHeader = styled.p`
  color: #232323;
  font-weight: 700;
  font-size: 1.5rem;
  margin-bottom: 1rem;
  border-bottom: 1px solid #b2b2b2;
  align-self: flex-start;
`;

const Link = styled(RouterLink)`
  text-decoration: none;
  position: relative;
  z-index: 1;
  color: currentColor;
  transition: color 0.2s;
  &:hover {
    color: #333;
  }
`;

const Copyright = styled.p`
  margin: 0 auto;
  max-width: 120rem;
  font-size: 1.25rem;
  padding-top: 1rem;
  padding-bottom: 5rem;
`;

export default Footer;
